module.exports = __webpack_public_path__ + "static/media/Symphony Nr 10.f7a0be77.png";